import { AgGroup } from '@indigo-ag/schema';

/**
 * Validates if it is necessary to send negotiations to the Fund
 * @param cessionGroup - To get the negotiations related with a particular group
 * @param criteria - Null used to check if there is at least one element to be sent.
 *                   false means that there is at least one element to be REsent
 * @returns Boolean to confirm the mentioned criteria
 */
export const haveToSendToFund = (cessionGroup: AgGroup, criteria: boolean | null = null): boolean => {
  return cessionGroup?.agFinancingProcesses?.some(
    agFinancingProcess => agFinancingProcess?.phase4?.postedToFund === criteria
  );
};
